import React from 'react';
import { LayoutContext } from '../layout/LayoutContext';
import { ModalContext } from '../modal/ModalContext';

// A higher order component that will provide both layout and modal contexts to a passed component.
// The contexts will be available to the component through props (i.e. this.props.layoutContext, this.props.modalContext)
const withLayoutAndModalContexts = WrappedComponent => props => (
	<LayoutContext.Consumer>
		{layoutContext => (
			<ModalContext.Consumer>
				{modalContext => (
					<WrappedComponent
						layoutContext={layoutContext}
						modalContext={modalContext}
						{...props}
					/>
				)}
			</ModalContext.Consumer>
		)}
	</LayoutContext.Consumer>
);

export default withLayoutAndModalContexts;
